export default __webpack_public_path__ + "static/media/LouverLevel3.f0c43e79.svg";